import { useState } from "react";

export default function Portfolio() {
  var style = {
    wrapper: {
      backgroundColor: "#ecedef",
      border: "8px solid",
      padding: "1rem",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "96px",
    },
    child: {
      backgroundColor: "#f0f0f0",
      border: "8px solid",
      padding: "1rem",
      marginBlockStart: "auto",
      // marginTop: "auto",
    },
    listWrapper: {
      width: "960px",
      marginInline: "auto",
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      flexWrap: "wrap",
    },

    listWrapperTitle: {
      fontWeight: "bold",
    },
  };
  return (
    <div style={style.wrapper}>
      <h1>
        {" "}
        <img
          width="880"
          height="121"
          src="/img/portfolio_logo.svg"
          alt="Portfolio"
          style={{
            "margin-inline-start": "-1.1rem",
            "margin-block-start": "-1.4rem",
          }}
        />
      </h1>
      <p style={{ textAlign: "center" }}>
        <img
          src="/img/icon_masahiko_800.jpg"
          width="250"
          height="250"
          alt=""
          style={{ "border-radius": "100%" }}
        />
      </p>
      <dl>
        <div style={style.listWrapper}>
          <dt style={style.listWrapperTitle}>登壇</dt>
          <dd>HTML5 Conference 2018（動員約1600名、登壇部屋 約150名）</dd>
          <dd>CSS組版‧ パブリッシング交流会</dd>
          <dd>デザイナー ミーツエンジニア</dd>
          <dd>KROWL 「デザイナ ーの仕事とホンネ」</dd>
        </div>
        <div style={style.listWrapper}>
          <dt style={style.listWrapperTitle}>得意・業務経験あり</dt>
          <dd>UIモック</dd>
          <dd>デザインレビュー</dd>
          <dd>デザイン研修</dd>
          <dd>Figma</dd>
          <dd>HTML</dd>
          <dd>CSS</dd>
        </div>
      </dl>
      <dl style={style.listWrapper}></dl>
    </div>
  );
}

function Square({ value, onSquareClick }) {
  return (
    <button className="square" onClick={onSquareClick}>
      {value}
    </button>
  );
}

function Board() {
  const [xIsNext, setXIsNext] = useState(true);
  const [squares, setSquares] = useState(Array(9).fill(null));

  function handleClick(i) {
    if (squares[i] || calculateWinner(squares)) {
      return;
    }
    const nextSquares = squares.slice(); // Copy the squares array
    if (xIsNext) {
      nextSquares[i] = "X";
    } else {
      nextSquares[i] = "O";
    }
    setSquares(nextSquares);
    setXIsNext(!xIsNext);
  }

  const winner = calculateWinner(squares);
  let status;
  if (winner) {
    status = "Winner:" + winner;
  } else {
    status = "Next player: " + (xIsNext ? "X" : "O");
  }

  return (
    <>
      <div className="status">{status}</div>
      <div className="board-row">
        <Square value={squares[0]} onSquareClick={() => handleClick(0)} />
        <Square value={squares[1]} onSquareClick={() => handleClick(1)} />
        <Square value={squares[2]} onSquareClick={() => handleClick(2)} />
      </div>
      <div className="board-row">
        <Square value={squares[3]} onSquareClick={() => handleClick(3)} />
        <Square value={squares[4]} onSquareClick={() => handleClick(4)} />
        <Square value={squares[5]} onSquareClick={() => handleClick(5)} />
      </div>
      <div className="board-row">
        <Square value={squares[6]} onSquareClick={() => handleClick(6)} />
        <Square value={squares[7]} onSquareClick={() => handleClick(7)} />
        <Square value={squares[8]} onSquareClick={() => handleClick(8)} />
      </div>
    </>
  );
}

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}
